/** Read `hybrid_player_id` from the hybrid JWT (see netplay_user_api hybrid login `jwt.sign`). */
export function getHybridPlayerIdFromUserToken(): number | null {
	const token =
		localStorage.getItem("user_token") || sessionStorage.getItem("user_token");
	if (!token || !token.includes(".")) return null;
	const parts = token.split(".");
	if (parts.length < 2) return null;
	const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
	const padded = base64.padEnd(
		base64.length + ((4 - (base64.length % 4)) % 4),
		"="
	);
	try {
		const payload = JSON.parse(atob(padded)) as { hybrid_player_id?: unknown };
		const id = Number(payload.hybrid_player_id);
		return Number.isFinite(id) && id > 0 ? id : null;
	} catch {
		return null;
	}
}
